namespace Recommendations {

    // Recommended Destination (as returned by API)
    export interface RecommendedDestination {
        HolidayEnabled: boolean;
        HotelCount: number;
        MinFlightPrice: number;
        MinHotelPrice: number;
        ObjectId: number;
        ObjectTypeId: Core.Destinations.DestinationType;
        PagePath: string;
        Searchable: boolean;
        Title: string;
    }

    //A structure of destination to help with serialising bd4 destinations.
    export class Bd4Destination {
        Type: number;
        Id: number;
        //A representation of the Type and Id as used by bd4.  E.G.  tr3:12345
        fullyQualifiedId: string;

        // The type system around destinations has become insane.
        // Try to parse a wide range of inputs.
        constructor(x: any) {
            if (angular.isString(x) && x.indexOf('tr') === 0) {
                x = x.match(/tr(\d+):(\d+)/);
                x = {
                    Type: parseInt(x[1], 10),
                    Id: parseInt(x[2], 10)
                };
            } else {
                x = x || {};
                x = x.searchModel || x;
                x = x.destination || x;
                x = x.object || x;
                x = x[0] || x;
                x = {
                    Type: x.Type || x.ObjectTypeId || (x.idType || '').replace('tr',''),
                    Id: x.Id || x.ObjectId || x.id
                };
            }
            x.fullyQualifiedId = `tr${x.Type}:${x.Id}`;
            return x;
        }
    }

    export interface SearchCookie {
        guid: string;
        destinations: Bd4Destination[];
    }
}
